import { render, staticRenderFns } from "./PenaltyStatistic.vue?vue&type=template&id=83cdfde8&scoped=true&"
import script from "./PenaltyStatistic.vue?vue&type=script&lang=js&"
export * from "./PenaltyStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cdfde8",
  null
  
)

export default component.exports